import type { ReactNode } from 'react';
import styles from './index.module.scss';

type PageHeroProps = {
  image: string;
  alt?: string;
  /** 标题型头图：文案距顶 180px 水平居中。下载页等内容型头图传 false。 */
  centered?: boolean;
  className?: string;
  innerClassName?: string;
  children: ReactNode;
};

export default function PageHero({
  image,
  alt = '',
  centered = true,
  className,
  innerClassName,
  children,
}: PageHeroProps) {
  const heroClass = className ? `${styles.hero} ${className}` : styles.hero;
  const innerClass = [styles.inner, centered ? styles.centered : '', innerClassName]
    .filter(Boolean)
    .join(' ');

  return (
    <section className={heroClass}>
      <div className={styles.media}>
        <img src={image} alt={alt} />
      </div>
      <div className={innerClass}>{children}</div>
    </section>
  );
}
